import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';


const CaptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Caption = styled.h2`
  width: 200px;
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.3em;
  text-align: center;
  margin: 0;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    width: 100%;
    text-align: right;
  }
`;

const GotIdea = () => {
  const { t } = useTranslation();

  return (
    <CaptionWrapper>
      <Caption>
        {t('gotAnIdeaWriteToUs')}
      </Caption>
    </CaptionWrapper>
  );
};

export default GotIdea;
